<template>
  <div class="ui-wrap">
    <div class="ui-box">
      <p class="head">{{ $t('title') }}</p>
      <div class="content">
        <h3 class="title">{{ $t('info') }}</h3>
        <table class="list">
          <colgroup>
            <col style="width: 24px" />
            <col />
            <col style="width: 250px" />
            <col style="width: 100px" />
          </colgroup>
          <tr v-for="(item, index) in orderInfo.timeArr">
            <td><i class="dot"></i></td>
            <td>
              <span>{{ getTime(item) }}</span>
            </td>
            <td>
              <span>1 {{ $t('common.lessons') }}</span>
            </td>
            <td>
              <b
                >US$ {{ teacherInfo.coursePrice }}/{{ $t('common.lessons') }}</b
              >
            </td>
            <td>
              <el-select
                class="ui-select"
                :placeholder="$t('form.placeholder')"
                style="width: 200px"
                v-model="courseIds[index]"
              >
                <el-option
                  v-for="(val, index) in courseList"
                  :key="index"
                  :value="val.courseId"
                  :label="val.courseName"
                ></el-option>
              </el-select>
              <!-- <label class="ui-radio">{{ teacherInfo.courseName }}</label> -->
            </td>
          </tr>
        </table>
        <p class="tips">
          {{ $t('tip1') }} <br />
          {{ $t('tip2') }}
        </p>
        <h3 class="title">{{ $t('amount') }}</h3>
        <p class="price">
          US$ {{ teacherInfo.coursePrice * orderInfo.timeArr.length }}
        </p>
        <h3 class="title">{{ $t('type') }}</h3>
        <ul class="paylist">
          <li :class="{ on: type === 'balance' }" @click="setBanlance">
            <span>{{ $t('balance') }}：US$ {{ balance }}</span>
          </li>
          <!-- <li :class="{on: type === 'alipay_web'}" @click="type = 'alipay_web'" class="alipay"></li>
          <li :class="{on: type === 'weixin_qrcode'}" @click="type = 'weixin_qrcode'" class="wechatpay"></li> -->
          <li
            :class="{ on: type === 'pay_pal' }"
            @click="type = 'pay_pal'"
            class="paypal"
          ></li>
        </ul>
        <!-- <p class="tips">说明：余额不足，则无法选择余额支付。微信支付宝，调取支付接口，扫码支付。</p> -->
      </div>
      <div class="btns">
        <a class="ui-btn gray" href="javascript: history.go(-1);">{{
          $t('cancel')
        }}</a>
        <a class="ui-btn" @click="gopay">{{
          loading ? '支付请求中...' : $t('user.gopay')
        }}</a>
      </div>
    </div>
    <pop
      :timeArr="orderInfo.timeArr"
      :info="teacherInfo"
      :show="showPop"
      :courseIds="courseIds"
      :courseList="courseList"
      :type="type"
    ></pop>
    <qrcode :show="showQrcode"></qrcode>
  </div>
</template>
<script>
import { getBaseProfile } from '@/service/teacherApi.js'
import { getOrder, orderCourse, payOrder } from '@/service/studentApi.js'
import { getAmount, getCourseList } from '@/service/api.js'
import Select from '@/components/Select.vue'
import pop from '@/components/Paypassword.vue'
import qrcode from '@/components/Qrcode.vue'
import moment from 'moment'
export default {
  components: { pop, Select, qrcode },
  data() {
    return {
      showPop: false,
      showQrcode: false,
      orderInfo: {},
      teacherInfo: '',
      balance: 0,
      type: 'pay_pal',
      orderList: [],
      loading: false,
      courseList: [],
      courseIds: []
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getOrder()
    } else {
      this.orderInfo = JSON.parse(this.$route.query.data)
      this.getBaseProfile()
    }
    this.getCourseList();
    this.getAmount()
  },
  methods: {
    async getCourseList() {
      let res = await getCourseList()
      if (res.data.status === 1) {
        this.courseList = res.data.data
      }
    },
    async getBaseProfile() {
      const res = await getBaseProfile({ teacherId: this.orderInfo.teacherId })
      if (res.data.status === 1) {
        this.teacherInfo = res.data.data
      }
    },
    async getAmount() {
      const res = await getAmount()
      if (res.data.status === 1) {
        this.balance = res.data.balance
      }
    },
    async getOrder() {
      const res = await getOrder({ orderCode: this.$route.query.id })
      // console.log(res);
      if (res.data.status === 1) {
        this.orderInfo.teacherId = res.data.data.teacherId
        let arr = res.data.data.courseList
        this.orderInfo.timeArr = []
        for (let i = 0; i < arr.length; i++) {
          this.orderInfo.timeArr.push(arr[i].beginTime * 1000)
          this.orderInfo.courseId = 1;
        }
        this.getBaseProfile()
      }
    },
    setBanlance() {
      if (this.teacherInfo.coursePrice * this.orderInfo.timeArr.length < this.balance) {
        this.type = 'balance'
      }
    },
    getTime(obj) {
      obj = parseInt(obj)
      const day = moment(obj).format('dddd  ')
      console.log(day);
      const day2 = moment(obj).format('YYYY-MM-DD HH:mm —— ')
      const day3 = moment(obj).add(1, 'h').format('HH:mm')
      return day + day2 + day3
    },
    gopay() {
      if (!this.loading) {
        if (this.type == 'balance') {
          for (let i = 0; i < this.orderInfo.timeArr.length; i++) {
            if (!this.courseIds[i]) {
              this.loading = false
              return this.$message.error(this.$t('form.selectCourse'));
            }else{
              this.showPop = true
            }
          }
        } else {
          this.loading = true
          this.goPaypal()
        }
      }
    },
    async goPaypal() {
      let obj = []
      for (let i = 0; i < this.orderInfo.timeArr.length; i++) {
        if (!this.courseIds[i]) {
          this.loading = false
          return this.$message.error(this.$t('form.selectCourse'));
        }
        obj.push({ beginTime: moment(parseInt(this.orderInfo.timeArr[i])).format("X"), endTime: moment(parseInt(this.orderInfo.timeArr[i])).add(1, 'h').format("X"), courseId: this.courseIds[i], courseName: this.courseList.find(item => item.courseId === this.courseIds[i]).courseName, courseCount: 1 })
      }
      const res = await orderCourse({ teacherId: this.teacherInfo.teacherId, products: JSON.stringify(obj), payChannel: this.type })
      if (res.data.status === 1) {
        const res2 = await payOrder(res.data.data)
        if (res2.data.status === 1) {
          window.location.href = res2.data.data.approveUrl
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head {
  padding: 50px 0 40px;
  line-height: 42px;
  text-align: center;
  font-size: 32px;
  border-bottom: 1px solid #d6d6d6;
}
.content {
  padding: 50px 80px 0;
}
.title {
  font-size: 21px;
}
.list {
  td:nth-child(4) {
    width: 20%;
  }
  margin-top: 13px;
  width: 100%;
  line-height: 52px;
  .dot {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    border: 4px solid #ff9b04;
    vertical-align: middle;
  }
}
.tips {
  color: #999;
  padding-left: 24px;
  line-height: 19px;
  margin-bottom: 50px;
}
.price {
  margin: 30px 0 50px;
  color: #ff9b04;
  font-size: 32px;
}
.paylist {
  margin: 30px 0 50px;
  overflow: hidden;
  li {
    float: left;
    margin: 0 5px;
    width: 240px;
    height: 82px;
    border: 1px solid #e2e2e2;
    border-radius: 12px;
    line-height: 80px;
    text-align: center;
    color: #002147;
    font-size: 18px;
  }
  .alipay {
    background: url(../assets/alipay.jpg) no-repeat center center;
  }
  .wechatpay {
    background: url(../assets/wechatpay.jpg) no-repeat center center;
  }
  .paypal {
    background: url(../assets/paypal.jpg) no-repeat center center;
  }
  .on {
    border-color: #0086ea;
  }
}
.btns {
  padding: 50px 0 80px;
  text-align: center;
  border-top: 1px solid #e2e2e2;
  .ui-btn {
    margin: 0 25px;
  }
}
</style>
<i18n>
{
  "cn": {
    "title": "订单支付",
    "info": "订单信息",
    "amount": "订单金额",
    "type": "支付方式",
    "balance": "余额",
    "tip1": "课堂开始48小时之前，支持取消课堂，退款至账户;",
    "tip2": "课堂开始48小时之内，支持改签"
  },
  "TW": {
    "title": "訂單支付",
    "info": "訂單資訊",
    "amount": "訂單金額",
    "type": "支付方式",
    "balance": "餘額",
    "tip1": "課堂開始48小時之前，支持取消課堂，退款至帳戶;",
    "tip2": "課堂開始48小時之內，支持改簽"
  },
  "en": {
    "title": "Order payment",
    "info": "Order summary",
    "amount": "Order amount ",
    "type": "Payment method",
    "balance": "Balance",
    "tip1": "Cancellation is allowed up to 48 hours in advance of the start of the lesson;",
    "tip2": "under 48 hours, rescheduling of the lesson is possible."
  }
}
</i18n>